import React from 'react';
import Product from "../components/Product";
import {ProfilesIcon2, ProfilesIcon4} from "../assets/imageAssets";

const TOPICS = [
    {
        id: 1,
        title: 'Job Stability',
        description: 'Assess your current job stability and see how it compares with national and industry trends.',
    },
    {
        id: 2,
        title: 'Career Growth Opportunities',
        description: 'Reflect on your career advancement options and compare them with opportunities others report.',
    },
    {
        id: 3,
        title: 'Risk of Job Loss',
        description: 'Evaluate your perceived job security and compare it to broader workforce risk factors.',
    },
    {
        id: 4,
        title: 'Employment Benefits',
        description: 'Share your employment benefits and compare them with what’s typical in your region and sector.',
    },
    {
        id: 5,
        title: 'Remote Work Flexibility',
        description: 'Indicate your remote work options and benchmark them against growing workplace flexibility trends.',
    },
];

const CareerSecurity = () => {
    return (
        <Product
            title={'Career Security'}
            description={'Explore job stability, financial confidence, and how secure people feel across Europe.'}
            icon={ProfilesIcon4}
            pageColor={'red'}
            topicsList={TOPICS}
        />
    );
}

export default CareerSecurity;
